/**
 * Copyright IBM Corp. 2016, 2018
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
import * as FeatureFlags from '@carbon/feature-flags';
import { default as TimePickerNext } from './next/TimePicker';
import { default as TimePickerClassic } from './TimePicker';
var TimePicker = FeatureFlags.enabled('enable-v11-release') ? TimePickerNext : TimePickerClassic;
export default TimePicker;